import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default function useWeButton () {
  const store = useStore()
  const router = useRouter()

  const stepOrder = computed(() => store.state.stepper.stepOrder)
  const stepper = computed(() => store.state.stepper.stepper)
  const activeStep = computed(() => store.getters.getActiveStep)

  const activeIndex = computed(() =>
    stepOrder.value.indexOf(activeStep.value)
  )

  const stepRouteName = computed(() => {
    if (!activeStep.value) return null
    return stepper.value[activeStep.value]?.routeName ?? null
  })

  const nextStepKey = computed(() => {    
    if (activeIndex.value === -1) return null
    return stepOrder.value[activeIndex.value + 1] ?? null
  })

  const nextStepRouteName = computed(() => {
    if (!nextStepKey.value) return null
    return stepper.value[nextStepKey.value]?.routeName ?? null
  })

  function getNextStepKey (currentStep) {
    const index = stepOrder.value.indexOf(currentStep)
    if (index === -1) return null
    return stepOrder.value[index + 1] ?? null
  }

  async function nextStep (phone) {
    if (!activeStep.value) {
      store.dispatch('setActiveStep', stepOrder.value[0])
      return
    }

    store.dispatch('updateStep', { stepKey: activeStep.value, value: true })

    if (activeStep.value === 'contract') {
      const sessionUuid = localStorage.getItem('session_uuid')
      const session = await store.dispatch('fetchSession', sessionUuid)

      if (session?.status === 'telephony') {
        store.dispatch('setActiveStep', 'telephony')
        router.push({ name: stepper.value.telephony.routeName, replace: true })
      } else {
        store.dispatch('updateStep', { stepKey: 'telephony', value: true })
        store.dispatch('setActiveStep', 'documents')
        router.push({ name: stepper.value.documents.routeName, replace: true })
      }

      return
    }

    const nextKey = getNextStepKey(activeStep.value)
    if (!nextKey) return

    store.dispatch('setActiveStep', nextKey)
    router.push({ name: stepper.value[nextKey].routeName, replace: true })
  }

  async function checkAvailability (formData) {
    const sessionUuid = localStorage.getItem('session_uuid')

    const approved = await store.dispatch(
      'checkAvailability',
      { formData, sessionUuid }
    )

    return approved
  }

  const weButtonOptions = {
    Confirm: {
      label: 'Contratar Plano',
      action: nextStep
    },
    Viability: {
      label: 'Ver disponibilidade',
      action: checkAvailability
    },
    ScheduleYourService: {
      label: 'Agendar contato',
      action: checkAvailability
    }
  }

  return {
    weButtonOptions,
    nextStep,
    checkAvailability
  }
}
